export default __webpack_public_path__ + "static/media/PPI-patio-029.aae38a99.jpg";